export default "__VITE_ASSET__49b85677__"